import React, { ReactNode } from 'react';
import { Button, Modal, Stack, Form, Row, Col } from 'react-bootstrap';
import { useFormik } from 'formik';
import { getLanguageProficiencies } from 'utils';
import { languageInitialValues, languageSchema } from 'constants/schemaValidations';
import useTranslate from 'hooks/useTranslate';
import useUserStore from 'store/user';
import ReactSelect from 'react-select';
import { LanguageInterface } from 'constants/interfaces';
import toast from 'react-hot-toast';
import { useUpdateUserDetailsMutation } from 'services';
import useCommonStore from 'store/common';

const AddLanguage: React.FC<any> = () => {
	const { translate } = useTranslate();
	const { profileData }: any = useUserStore((state) => state);
	const { languages: savedData = [] } = profileData;
	const { modalConfig = {} }: any = useCommonStore((state) => state);

	const { mutateAsync: updateProfile } = useUpdateUserDetailsMutation();
	const formik: any = useFormik({
		initialValues: {
			...languageInitialValues,
			...(Number.isInteger(modalConfig?.id) && savedData[modalConfig.id]
				? savedData[modalConfig.id]
				: {}),
		},
		validationSchema: languageSchema(translate),
		enableReinitialize: true,
		onSubmit: async (values: any) => {
			const limitedFieldsData: LanguageInterface[] = savedData;
			const newDatas = [...limitedFieldsData];
			if (Number.isInteger(modalConfig?.id)) {
				newDatas[modalConfig.id] = values;
			} else {
				newDatas.push(values);
			}
			updateProfile({ languages: newDatas, saveType: 'addLanguage' })
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
					}
				})
				.finally(() => modalConfig?.onClose());
		},
	});

	const renderError = <T extends keyof LanguageInterface>(field: T) =>
		formik.touched[field] && formik.errors[field] ? (
			<span className="text-danger f-error">{formik.errors[field] as ReactNode}</span>
		) : null;

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => modalConfig?.onClose()}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Form className="edit-form" onSubmit={formik.handleSubmit}>
				<Stack className="gap-4">
					<h4 className="fw-bold mb-0">{translate('Profile.addLanguage')}</h4>
					<Row>
						<Col md="6">
							<Form.Group className="mb-4 position-relative">
								<Form.Label className="lh-1">{translate('Profile.languageName')}</Form.Label>
								<Form.Control
									type="text"
									placeholder={translate('PlaceHolder.enterLanguageName')}
									name="title"
									className="rounded-pill"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.title}
									autoComplete="off"
								/>
								{renderError('title')}
							</Form.Group>
						</Col>
						<Col md="6">
							<Form.Group className="mb-4 position-relative">
								<Form.Label className="lh-1">{translate('Common.level')}</Form.Label>
								<ReactSelect
									isSearchable
									name="proficiency"
									options={getLanguageProficiencies}
									getOptionValue={(option) => option.value}
									getOptionLabel={(option) => option.label}
									onChange={(optionValue: any) => {
										formik.setFieldValue('proficiency', optionValue.value);
									}}
									onBlur={formik.handleBlur}
									autoFocus={false}
									placeholder={translate('PlaceHolder.addProficiency')}
									className="form-react-select"
									classNamePrefix="select"
									value={getLanguageProficiencies.find(
										(data: any) => data.value === formik.values.proficiency,
									)}
								/>
								{renderError('proficiency')}
							</Form.Group>
						</Col>
					</Row>
					<div className="edit-modal-actions d-flex gap-4">
						<Button className="filled-btn rounded-pill" type="submit">
							{translate('Common.save')}
						</Button>
					</div>
				</Stack>
			</Form>
		</Modal.Body>
	);
};

export default AddLanguage;
